import React, {Component} from 'react';
import {NavBar, Modal, Toast} from 'antd-mobile';
import "./style.less";
import {getOftenList,deleteOften} from "../../../service/memberService";
import {connect} from "react-redux";
const alert = Modal.alert;
const notPassenger = require('../../../common/image/notPassenger.png');
const dataError = require('../../../common/image/dataError.png');
@connect(
    state => ({userInfo: state.userInfo})
)
export default class OftenPassenger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:[],
            notDataLoading:0,
        };
    }
    componentDidMount() {
        this.getOftenList()
    };
    getOftenList(){
        Toast.loading('',0);
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {pageSize:100, pageNum:1}
        };
        getOftenList(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.hide()
                if(res.data.data.list.length > 0){
                    this.setState({data: res.data.data.list,});
                }else{
                    this.setState({notDataLoading:1});
                }
            } else {
                Toast.info(res.data.msg,3);
                this.setState({notDataLoading:2});
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
    detele(res){
        Toast.loading('',0);
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {id:res.id}
        };
        deleteOften(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("删除成功",2,()=>window.location.reload());
            } else {
                Toast.info(res.data.msg,3);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noMore">
                <img src={notPassenger} />
                <p>暂无常用乘客</p>
            </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noMore">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    render(){
        const {data,notDataLoading}=this.state;
        return(
            <div className="oftenPassenger">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                    rightContent={[
                        <i className="icon iconfont icontianjia" onClick={() => this.props.history.push('/addOftenPsg',)} key='icontianjia' />,
                    ]}
                >常用乘客</NavBar>
                <div className="warp">
                    {
                        notDataLoading == 0  ?
                          (data.map((res,i)=>(
                            <div className="box" key={i}>
                                <div className="info">
                                    <p className="name">{res.name}</p>
                                    <div className="phone"><i className="icon iconfont iconlianxishouji" />{res.phone}</div>
                                    <div className="sfz"><i className="icon iconfont iconshenfenzheng" />{res.idType == "idcard" ? "身份证" : res.idType == "passport" ?"护照" : "边民证"} {res.idNum}</div>
                                </div>
                                <div className="delete"><i className="icon iconfont iconshanchu" onClick={() =>
                                    alert('提示', '您确定要删除吗?', [
                                        { text: '取消'},
                                        { text: '确定', onPress: () => this.detele(res)},
                                    ])}/></div>
                            </div>
                        ))):
                           null

                    }

                    {this.notData()}

                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/member/OftenPassenger/index.js